'use strict';

/*@ngInject*/
module.exports = function () {
    return {
        restrict: 'A',
        controller: ['$scope', '$element', '$window', function ($scope, $element, $window) {
            var _this = this;

            angular.element($window).on('focus', function () {
                $scope.$apply(function () {
                    _this.enableScroll();
                });
            });
            angular.element($window).on('blur', function () {
                $scope.$apply(function () {
                    _this.disableScroll();
                });
            });

            this.disableScroll = function () {
                // Get the current page scroll position
                var scrollTop = window.pageYOffset || document.documentElement.scrollTop;
                var scrollLeft = window.pageXOffset || document.documentElement.scrollLeft;

                // if any scroll is attempted,
                // set this to the previous value
                window.onscroll = function () {
                    window.scrollTo(scrollLeft, scrollTop);
                };
            };

            this.enableScroll = function () {
                window.onscroll = function () {};
            };
        }]
    };
};


/** WEBPACK FOOTER **
 ** ./app/shared/directives/prevent-scroll.directive.js
 **/